import { schema } from 'normalizr';
import trainingPlanCourse from './trainingPlanCourse';

const trainingPlanLabel = new schema.Entity('labels', {
  optionalCourses: [trainingPlanCourse],
  targetCourses: [trainingPlanCourse],
});

export default trainingPlanLabel;
